import { render, staticRenderFns } from "./pourquoi-creer-un-site-internet-vitrine-5-raisons.vue?vue&type=template&id=fb844c12&"
import script from "./pourquoi-creer-un-site-internet-vitrine-5-raisons.vue?vue&type=script&lang=js&"
export * from "./pourquoi-creer-un-site-internet-vitrine-5-raisons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports